import Vue from "vue";
export default {
  namespaced: true,
  state: {
    configuratorOpen: false,
    config: {},
    selectedOptions: {},
    previews: {},
    magentoData: null,
    exportedImage: null,
    quantity: 1,
    error: null,
    previousStep: null,
    currentStep: null,
    stepOptionStatuses: {},
    invalidOptions: [],
    invalidStep: null,
    qtyAddedToCart: 0,
    qtyDesignsSaved: 0
  },
  mutations: {
    setConfig(state, config) {
      console.log('configs here');
      console.log(config);
      state.config = config;
    },
    setMagentoData(state, magentoData) {
      state.magentoData = magentoData;
    },
    setSelectedOption(state, selectedOption) {
      Vue.set(state.selectedOptions, selectedOption.key, selectedOption.value);
    },
    deleteSelectedOption(state, optionId) {
      Vue.delete(state.selectedOptions, optionId);
    },
    addPreview(state, preview) {
      Vue.set(state.previews, preview.id, {});

      preview.elements
        .sort((a, b) => (a.zIndex > b.zIndex ? 1 : -1))
        .map(el => {
          el.config.id = el.id;
          Vue.set(state.previews[preview.id], el.id, el);
        });
    },
    setExportedImage(state, base64Img) {
      state.exportedImage = base64Img;
    },
    setQuantity(state, qty) {
      state.quantity = parseInt(qty);
    },
    setError(state, error) {
      state.error = error;
    },
    setCurrentStep(state, step) {
      state.previousStep = state.currentStep;
      state.currentStep = step;
    },
    toggleConfigurator(state, status) {
      state.configuratorOpen = status;
    },
    setStepOptionStatus(state, optionStatus) {
      Vue.set(
        state.stepOptionStatuses,
        optionStatus.optionId,
        optionStatus.status
      );
    },
    setInvalidOptions(state, options) {
      state.invalidOptions = options;
    },
    setInvalidStep(state, step) {
      state.invalidStep = step;
    },
    increaseAddedToCartAmount(state) {
      state.qtyAddedToCart = state.qtyAddedToCart + state.quantity;
    },
    increaseSavedDesignAmount(state) {
      state.qtyDesignsSaved++;
    }
  },
  getters: {
    activeOptions: function (state) {
      if (state.config.options) {
        return state.config.options.filter(option => {
          if (option.hasOwnProperty("conditions")) {
            let conclusion = false;
            let conjuncts = option.conditionsConjuncts || false;

            for (let condition of option.conditions) {
              let selectionValue = state.selectedOptions[condition.option]
                ? state.selectedOptions[condition.option][condition.property]
                : "";

              let compare = function (f, o, b) {
                if (o == "eq") return f == b;
                else if (o == "neq") return f != b;
                else if (o == "lt") return f < b;
                else if (o == "le") return f <= b;
                else if (o == "gt") return f > b;
                else if (o == "ge") return f >= b;
                else return false;
              }
              conclusion = compare(selectionValue, condition.operator, condition.value);

              // Break if first true value is found OR if conjucts is on and false value is found
              if ((conjuncts && !conclusion) || (!conjuncts && conclusion)) {
                break;
              }
            }
            return conclusion;
          } else return true;
        });
      } else return [];
    },
    activeSteps: function (state, getters) {
      if (state.config.steps) {
        let activeOptionIds = getters.activeOptions.map(option => option.id);
        let summaryStep = { "id": "summary", "title": "Summary" };
        let optionSteps = state.config.steps.filter(step =>
          step.options ? step.options.every(optionId => activeOptionIds.includes(optionId)) : true
        );
        return [...optionSteps, summaryStep];
      } 
      else return [];
    },
    fullPreviewElements: function (state) {
      // Loop through selected options
      for (let selectedOption of Object.values(state.selectedOptions)) {
        let selectedOptionPreviewMutations = selectedOption.previewMutations;

        if (selectedOptionPreviewMutations) {
          // Loop through selectes option's mutateable previews (front, closure, back etc...)
          for (let selectedOptionMutateableViews of Object.entries(
            selectedOptionPreviewMutations
          )) {
            let view = selectedOptionMutateableViews[0], // = e.g. front/back/closure
              mutations = selectedOptionMutateableViews[1]; // = array of objects like this: { element: "handle", property: "image" }

            // Skip view, if it's not found
            if (!state.previews[view]) {
              continue;
            }

            // Loop through selectes option's mutateable preview's elements
            for (let mutation of mutations) {

              // Skip if element not found
              if (!state.previews[view][mutation.element]) { continue; }

              // Declare empty mutated object
              if (!state.previews[view][mutation.element].mutated) {
                Vue.set(state.previews[view][mutation.element], "mutated", {});
              }
              // Value = option's value
              let value = selectedOption.value;

              // Use preview value if set
              if (selectedOption.previewValue) {
                if (typeof selectedOption.previewValue === "object") {
                  value = selectedOption.previewValue[mutation.value];
                } else {
                  value = selectedOption.previewValue;
                }
              }

              // Set option value to preview element
              Vue.set(
                state.previews[view][mutation.element].mutated,
                mutation.property,
                value
              );
            }
          }
        }
      }

      return state.previews;
    },
    subtotal: function (state) {
      let subTotal = state.config.product ? state.config.product.price : 0;

      for (let key of Object.keys(state.selectedOptions)) {
        subTotal += state.selectedOptions[key].price || 0; // Option price
      }

      return subTotal;
    },
    currentStepOptions(state) {
      if (state.config.hasOwnProperty('steps')) {
        let currentStep = state.config.steps.filter(
          step => step.id === state.currentStep
        );
        return currentStep.length && currentStep[0].options
          ? currentStep[0].options
          : [];
      }
      return [];
    },
    stepDirection(state, getters) {
      if (state.config.steps) {
        let stepIds = getters.activeSteps.map(step => step.id);
        return stepIds.indexOf(state.currentStep) < stepIds.indexOf(state.previousStep) ? -1 : 1;
      }
      return 1;
    }
  },
  actions: {
    setConfig({ commit }, config) {
      commit("setConfig", config);
    },
    setMagentoData({ commit }, magentoData) {
      commit("setMagentoData", magentoData);
    },
    setSelectedOption({ commit }, selectedOption) {
      commit("setSelectedOption", selectedOption);
    },
    deleteSelectedOption({ commit }, optionId) {
      commit("deleteSelectedOption", optionId);
    },
    addPreview({ commit }, preview) {
      commit("addPreview", preview);
    },
    setExportedImage({ commit }, base64Img) {
      commit("setExportedImage", base64Img);
    },
    setQuantity({ commit }, qty) {
      commit("setQuantity", qty);
    },
    setError({ commit }, error) {
      commit("setError", error);
    },
    setCurrentStep({ commit }, step) {
      commit("setCurrentStep", step);
    },
    toggleConfigurator({ commit }, status) {
      const el = document.body;
      const className = "visualizer-no-scroll";

      if (status) {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
      commit("toggleConfigurator", status);
    },
    setStepOptionStatus({ commit }, optionStatus) {
      commit("setStepOptionStatus", optionStatus);
    },
    setInvalidOptions({ commit }, options) {
      commit("setInvalidOptions", options);
    },
    setInvalidStep({ commit }, step) {
      commit("setInvalidStep", step);
    },
    increaseAddedToCartAmount({ commit }) {
      commit("increaseAddedToCartAmount");
    },
    increaseSavedDesignAmount({ commit }) {
      commit("increaseSavedDesignAmount");
    }
  }
};
